import { AxDropdown } from "@axess/limestone";
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { addUniqueObjectToArray } from "../../../Lib/Helper/ObjectHelper";
import { CompPackOrderLessonValues } from "../../../Models/ComplexPackages/BookingOptions/CompPackOrderLessonValues";
import { Lesson } from "../../../Models/Lesson/Lesson";
import { ComplexPackageBookingOptions } from "../ComplexPackageBookingOptions";

@ModuleName("CompPackBookingLessonOptions")
export class CompPackBookingLessonOptions implements AxInit {
    private cpBookingOptions: ComplexPackageBookingOptions = AxLoad.GetModule<ComplexPackageBookingOptions>("ComplexPackageBookingOptions");
    private lessonOrderValues: Lesson[] = [];

    AxInit(init: initData): void {
        this.lessonOrderValues = JSON.parse(init.lessonOrderValues && init.lessonOrderValues !== '' ? init.lessonOrderValues : '[]');
        this.lessonOrderValues.forEach((lesson: Lesson) => this.addTimeSlotSelectListener.call(this, lesson));
    }

    addTimeSlotSelectListener(lesson: Lesson) {
        const $opener = $(`.prod_selection__lesson-selection-${lesson.lessonWebNr}-${lesson.lessonArcNr}-${lesson.lessonDefNr}`);

        if ($opener.length > 0) {
            $opener.off();
            const dropdown = new AxDropdown();
            dropdown.init(`.prod_selection__lesson-selection-${lesson.lessonWebNr}-${lesson.lessonArcNr}-${lesson.lessonDefNr} .ax-dropdown`, {
                searchBar: false,
                multiSelect: false,
                onSelect: ($parent: any, value: string) => {
                    const tippy = $parent.get(0)._tippy;
                    const dataset = tippy?.props?.content?.querySelector(`[data-value="${value}"]`)?.dataset || {};
                    const order = this.lessonOrderValues.find((orderValue: Lesson) => (
                        orderValue.rentalItemNr === Number(dataset.rentalitemnr)
                    ));
                    if (order) {
                        this.addLessonValues(
                            order.lessonsNr,
                            order.lessonWebNr,
                            order.lessonArcNr,
                            order.lessonDefNr,
                            order.lessonTypeNr,
                            order.packagePositionNr,
                            dataset.from,
                            dataset.to,
                            dataset.rentalitemnr,
                        );
                    }
                },
            });
            this.cpBookingOptions.dropDowns = addUniqueObjectToArray(this.cpBookingOptions.dropDowns, dropdown, 'selector');
        } else {
            this.addLessonValues(
                lesson.lessonsNr,
                lesson.lessonWebNr,
                lesson.lessonArcNr,
                lesson.lessonDefNr,
                lesson.lessonTypeNr,
                lesson.packagePositionNr,
                lesson.from,
                lesson.to,
                lesson.rentalItemNr,
            );
        }
    }

    addLessonValues(
        lessonsNr: number,
        lessonWebNr: number,
        lessonArcNr: number,
        lessonDefNr: number,
        lessonTypeNr: number,
        packagePositionNr: number,
        from: string,
        to: string,
        rentalItemNr?: number,
    ) {
        const lessonValues = new CompPackOrderLessonValues(
            lessonsNr,
            lessonWebNr,
            lessonArcNr,
            lessonDefNr,
            lessonTypeNr,
            packagePositionNr,
            from,
            to,
            rentalItemNr,
        );
        this.cpBookingOptions.bookingValuesList.forEach((bookingValues) => {
            const index = bookingValues.lessonOrderValues.findIndex((e) => e.lessonWebNr === lessonWebNr && e.lessonArcNr === lessonArcNr && e.lessonDefNr === lessonDefNr);
            if (~index) {
                bookingValues.lessonOrderValues[index] = lessonValues;
            } else {
                bookingValues.lessonOrderValues = [...bookingValues.lessonOrderValues, lessonValues];
            }            
        });
    }
}

export interface initData {
    lessonOrderValues: string;
}